import { render } from "./UsersAdmin.vue?vue&type=template&id=088e2f59"
import script from "./UsersAdmin.vue?vue&type=script&lang=js"
export * from "./UsersAdmin.vue?vue&type=script&lang=js"

import "./UsersAdmin.vue?vue&type=style&index=0&id=088e2f59&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__